export const contactsReport = {
  id: 'candidates',
  name: 'Candidates',
  description: '',
  visibility: 'private',
  // API payload field — backend still expects `contacts`, do not rename.
  subject_type: 'contacts',
  layout: {
    data: [
      {
        h: 7,
        w: 3,
        x: 0,
        y: 0,
        key: '4779',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 3,
        y: 0,
        key: '4780',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 6,
        y: 0,
        key: '4781',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 9,
        y: 0,
        key: '4782',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 29,
        w: 12,
        x: 0,
        y: 7,
        key: '4783',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 18,
        w: 12,
        x: 0,
        y: 36,
        key: '4784',
        maxH: 100,
        maxW: 12,
        minH: 8,
        minW: 8,
      },
    ],
  },
  tiles: [
    {
      id: 4779,
      subject_type: 'contacts',
      metadata: {
        id: 'contacts_new',
        tileKey: 'contacts_new',
        apiParam: 'card',
        headerKey: 'contacts_created',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4780,
      subject_type: 'contacts',
      metadata: {
        id: 'contacts_sourced',
        tileKey: 'contacts_sourced',
        apiParam: 'card',
        headerKey: 'sourced',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4781,
      subject_type: 'contacts',
      metadata: {
        id: 'contacts_inbound',
        tileKey: 'contacts_inbound',
        apiParam: 'card',
        headerKey: 'inbound',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4782,
      subject_type: 'contacts',
      metadata: {
        id: 'contacts_referral',
        tileKey: 'contacts_referral',
        apiParam: 'card',
        headerKey: 'referral',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4783,
      subject_type: 'contacts',
      metadata: {
        id: 'contacts_chart',
        tileKey: 'contacts_chart',
        apiParam: 'chart_table',
        componentType: 'chart',
        defaultFilters: {
          group_by_2: 'contact_source',
        },
      },
      query: null,
    },
    {
      id: 4784,
      subject_type: 'contacts',
      metadata: {
        id: 'contacts_table',
        tileKey: 'contacts_table',
        apiParam: 'chart_table',
        headerKeys: [
          'contacts_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        componentType: 'table',
      },
      query: null,
    },
  ],
  user: {
    id: null,
  },
};
